module.exports = __webpack_public_path__ + "static/media/kaple-celek2.093ea487.jpg";